import { ContadoresDoSemestre as Contadores } from '../realizacoes-do-semestre';

/** RDN-07: os quatro contadores do ciclo selecionado. */
export default function ContadoresDoSemestre({ contadores }: { contadores: Contadores }) {
  const itens = [
    { rotulo: 'Cadastradas por você', valor: contadores.cadastradas },
    { rotulo: 'Validadas', valor: contadores.validadas },
    { rotulo: 'Aguardando validação', valor: contadores.aguardando },
    { rotulo: 'Participações', valor: contadores.participacoes },
  ];

  return (
    <dl aria-label="Realizações do ciclo" className="m-0 mt-3.5 grid grid-cols-2 gap-2.5 lg:grid-cols-4">
      {itens.map(item => (
        <div key={item.rotulo} className="flex flex-col-reverse justify-end gap-1.5 rounded-jj-lg bg-brand-white px-[18px] py-4 shadow-jj-01">
          <dt className="text-xs leading-[1.35] text-content-soft">{item.rotulo}</dt>
          <dd className="m-0 font-display text-2xl font-bold text-brand-blue">{item.valor}</dd>
        </div>
      ))}
    </dl>
  );
}
